var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLlline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254.26 255.605c6.876-8.22 28.55-47.384 41.256-49.327 12.705-1.943 20.926 40.508 34.977 37.668 14.051-2.84 36.024-49.776 49.328-54.708 13.303-4.933 19.88 29.447 30.493 25.112 10.613-4.335 20.03-46.189 33.184-51.121 13.154-4.933 31.988 28.25 45.74 21.524 13.752-6.726 30.642-51.57 36.771-61.883",
    fill: "none",
    strokeWidth: 19,
    stroke: "#66b58f",
    strokeLinecap: "round",
    transform: "matrix(1 0 .35265 1 -66.735 0)",
    strokeDasharray: "0 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlline);
export default __webpack_public_path__ + "static/media/llline.bd0f3a122759d538f74189be05c60ac2.svg";
export { ForwardRef as ReactComponent };